import {Headline, TextLink} from '@sdox/ui'
import {currency, twMerge} from '@sdox/utils'
import {AvailabilityEnum} from '@sdox/api'

import type {XcNwBlock_BlockSePriceType_Fragment} from '@sdox/api'

const availabilityMapper: Record<AvailabilityEnum, {color: string; text: string}> = {
  [AvailabilityEnum.Archived]: {color: 'bg-red-500', text: 'Nicht verfügbar'},
  [AvailabilityEnum.Available]: {color: 'bg-green-600', text: 'Verfügbar'},
  [AvailabilityEnum.Reserved]: {color: 'bg-orange-500', text: 'Reserviert'},
}

export const BlockSePrice = ({
  internalNumber,
  availability,
  price,
  tax = false,
  loan,
  leasing,
  loanPageId,
  leasingPageId,
}: XcNwBlock_BlockSePriceType_Fragment) => (
  <div className={'-mr-spacing-20 flex flex-row items-center justify-between gap-4 @medium/page:mr-[-12.55cqw]'}>
    {internalNumber !== null && (
      <div className={'grid grid-rows-2 items-center gap-x-4 gap-y-2 md:grid-cols-2'}>
        <span className={'hidden md:inline'}>Status:</span>
        <div className={'flex items-center justify-center gap-2 rounded-md bg-gray-100 p-2 text-sm'}>
          <span className={twMerge('size-4 rounded-full', availabilityMapper[availability].color)}/>
          <span>{availabilityMapper[availability].text}</span>
        </div>
        <span className={'hidden md:inline'}>Interne Nummer:</span>
        <div className={'flex items-center justify-center gap-2 break-all rounded-md bg-gray-100 p-2 text-sm'}>
          <span>{internalNumber}</span>
        </div>
      </div>
    )}
    {price !== null && price > 0 && ( // price can actually be 0.0 instead of null
      <div className={twMerge('bg-gray-100 p-3 text-right sm:px-8 md:px-16 lg:px-24')}>
        <Headline size={1}>
          {currency(price)}
        </Headline>
        {loan ? (
          <div>
            <TextLink href={`#${loanPageId}`}>Finanzierung {loan}/mtl.</TextLink>
          </div>
        ) : null}
        {leasing ? (
          <div>
            <TextLink href={`#${leasingPageId}`}>Leasing {leasing}/mtl.</TextLink>
          </div>
        ) : null}
        <p className={'whitespace-nowrap text-gray-500'}>
          {tax ? 'MwSt. ausweisbar' : 'MwSt. nicht ausweisbar'}
        </p>
      </div>
    )}
  </div>
)
